// extracted by mini-css-extract-plugin
var _1 = "duCVFTAN_1wkMvcnHadn";
var _2 = "bLeYoEo9L9jOMUme3Bgr";
var _3 = "ywtPb8N6TXpXN86RkEik";
var _4 = "h9usRB0AIldMc2u3DorW";
var _5 = "YoPPNrAUwilVamGukolm";
var _6 = "vviUUIp0Us6t0Cp97bRk";
export { _1 as "activeTab", _2 as "childrenContainer", _3 as "disabledTab", _4 as "tab", _5 as "tabs", _6 as "tabsContainer" }
